import Slide from "../../../../../../components/Slide";
import QList from "../../../../../../components/QList";
import QHeader from "../../../../../../components/QHeader";

import BackgroundImage from "../../../../../../assets/_Chapters/_Images/background/VerwaltungMessmittelUndElektrowerkzeuge/2.webp";
import { Grid } from "@material-ui/core";

export default function Verwaltung() {
  return (
    <Slide
      background={{
        image: BackgroundImage,
        width: "50dvw",
        align: "right",
        position: "center",
      }}
    >
      <Grid container spacing={5} alignItems="center">
        <Grid item xs={6}>
          <QHeader title="Elektronische Messmittelverwaltung" />
          <QList
            items={[
              "Klare Regelung von Zugriffsrechten",
              "Hinterlegung von Kalibrier-Rhythmen und automatische Sperre",
              "Abholung zur Kalibrierung durch SSV-Mitarbeiter möglich",
            ]}
          />
        </Grid>
        <Grid item xs={6}></Grid>
      </Grid>
    </Slide>
  );
}
